import { useEffect, useRef, useState } from "react";

const ChevronDown = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 9l6 6 6-6" />
    </svg>
);
const SearchIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
    </svg>
);
const XIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6L6 18M6 6l12 12" />
    </svg>
);

// Dropdown con buscador integrado — options: [{ value, label }]
// freeSolo: permite escribir un valor que no existe en options; onChange
// recibe el texto libre tal cual (usado, p. ej., para capturar áreas nuevas).
export const SearchSelect = ({
    options = [],
    value,
    onChange,
    placeholder = "Seleccione una opción",
    freeSolo = false,
}) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const containerRef = useRef(null);
    const searchRef = useRef(null);

    const selectedOption = options.find((opt) => String(opt.value) === String(value));

    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    useEffect(() => {
        if (open && searchRef.current) {
            setTimeout(() => searchRef.current?.focus(), 50);
        }
    }, [open]);

    const textoFiltro = freeSolo ? value ?? "" : search;

    const filtered = options.filter((opt) =>
        opt.label.toLowerCase().includes(textoFiltro.toLowerCase())
    );

    const existeCoincidenciaExacta = options.some(
        (opt) => opt.label.toLowerCase() === textoFiltro.trim().toLowerCase()
    );

    const handleSelect = (val) => {
        onChange(val);
        setOpen(false);
        setSearch("");
    };

    // Modo freeSolo: el propio trigger es un input editable.
    if (freeSolo) {
        return (
            <div className={"lead-select" + (open ? " lead-select--open" : "")} ref={containerRef}>
                <div className="lead-select__trigger lead-select__trigger--freesolo">
                    <input
                        type="text"
                        className="lead-select__freesolo-input"
                        placeholder={placeholder}
                        value={value ?? ""}
                        onChange={(e) => onChange(e.target.value)}
                        onFocus={() => setOpen(true)}
                        maxLength={200}
                    />
                    <ChevronDown />
                </div>

                {open && (
                    <div className="lead-select__dropdown">
                        <div className="lead-select__list scroll">
                            {filtered.length === 0 ? (
                                <div className="lead-select__empty">Sin coincidencias</div>
                            ) : (
                                filtered.map((opt) => (
                                    <div
                                        key={opt.value}
                                        className={
                                            "lead-select__option" +
                                            (String(opt.value) === String(value) ? " lead-select__option--selected" : "")
                                        }
                                        onClick={() => handleSelect(opt.value)}
                                    >
                                        {opt.label}
                                    </div>
                                ))
                            )}
                            {textoFiltro.trim() && !existeCoincidenciaExacta && (
                                <div
                                    className="lead-select__option lead-select__option--nueva"
                                    onClick={() => handleSelect(textoFiltro.trim())}
                                >
                                    Usar "{textoFiltro.trim()}" (nueva)
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={"lead-select" + (open ? " lead-select--open" : "")} ref={containerRef}>
            <button
                type="button"
                className="lead-select__trigger"
                onClick={() => setOpen((o) => !o)}
            >
                <span className={value ? "" : "lead-select__placeholder"}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <ChevronDown />
            </button>

            {open && (
                <div className="lead-select__dropdown">
                    <div className="lead-select__search">
                        <SearchIcon />
                        <input
                            ref={searchRef}
                            type="text"
                            className="lead-select__search-input"
                            placeholder="Buscar..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                        />
                        {search && (
                            <button
                                type="button"
                                className="lead-select__search-clear"
                                onClick={() => setSearch("")}
                                tabIndex={-1}
                            >
                                <XIcon />
                            </button>
                        )}
                    </div>

                    <div className="lead-select__list scroll">
                        {filtered.length === 0 ? (
                            <div className="lead-select__empty">
                                Sin resultados para "{search}"
                            </div>
                        ) : (
                            filtered.map((opt) => (
                                <div
                                    key={opt.value}
                                    className={
                                        "lead-select__option" +
                                        (String(opt.value) === String(value) ? " lead-select__option--selected" : "")
                                    }
                                    onClick={() => handleSelect(opt.value)}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchSelect;
